<script>
  import { onMount, onDestroy } from 'svelte';
  import Chart from 'chart.js/auto';

  export let title = '';
  export let value = '';
  export let data = [];
  export let labels = [];
  export let stats = [];
  export let height = 200;

  let chartCanvas;
  let chart;

  onMount(() => {
    if (!chartCanvas) return;

    const ctx = chartCanvas.getContext('2d');

    chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: title,
          data: data,
          borderColor: 'rgba(59, 130, 246, 0.8)',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 0,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        }
      }
    });
  });

  onDestroy(() => {
    if (chart) {
      chart.destroy();
    }
  });

  $: if (chart && data && labels) {
    chart.data.labels = labels;
    chart.data.datasets[0].data = data;
    chart.update();
  }
</script>

<div class="bg-white rounded-lg border border-gray-200 p-6">
  <div class="mb-4">
    <h3 class="text-lg font-semibold text-gray-900">{title}</h3>
    {#if value}
      <p class="text-3xl font-bold text-gray-900 mt-2">{value}</p>
    {/if}
  </div>

  <div style="height: {height}px;" class="mb-4">
    <canvas bind:this={chartCanvas}></canvas>
  </div>

  {#if stats.length > 0}
    <div class="grid grid-cols-3 gap-4 pt-4 border-t border-gray-200">
      {#each stats as stat}
        <div class="text-center">
          <p class="text-2xl font-bold text-gray-900">{stat.value}</p>
          <p class="text-xs text-gray-500">{stat.label}</p>
        </div>
      {/each}
    </div>
  {/if}
</div>
